import { StandardEvents } from '@shopify/events';
const metalsByWidth = {
  '4 mm': ['14K Yellow Gold','18K Yellow Gold','14K White Gold','18K White Gold','14K Rose Gold','Platinum'],
  '5 mm': ['18K Yellow Gold','18K White Gold'],
  '6 mm': ['18K Yellow Gold','18K White Gold','14K Rose Gold'],
  '7 mm': ['18K Yellow Gold','18K White Gold']
};
const tone = name => name.includes('Yellow') ? 'yellow' : name.includes('Rose') ? 'rose' : 'white';
document.addEventListener('change', event => {
  const input = event.target;
  const picker = input instanceof Element && input.closest('variant-picker.joa-band-picker');
  if (!picker || input.dataset.optionName !== 'Band Width') return;
  const allowed = metalsByWidth[input.value] || [];
  const selected = picker.querySelector('input[data-option-name="Material"]:checked');
  if (!selected || allowed.includes(selected.value)) return;
  const replacement = allowed.find(name => tone(name) === tone(selected.value)) || allowed[0];
  const control = Array.from(picker.querySelectorAll('input[data-option-name="Material"]')).find(item => item.value === replacement);
  if (control && typeof picker.updateSelectedOption === 'function') picker.updateSelectedOption(control);
}, true);
document.addEventListener(StandardEvents.productSelect, event => {
  if (!(event.target instanceof Element) || !event.target.closest('variant-picker.joa-band-picker')) return;
  event.promise?.then(({ detail }) => {
    const id = detail?.resource?.id;
    if (!id) return;
    const url = new URL(location.href);
    url.searchParams.set('variant', String(id).split('/').pop());
    history.replaceState({}, '', url);
  }).catch(() => {});
});